'use client';

import React, {
  createContext,
  useContext,
  // useEffect
} from 'react';
import { reducer } from './reducer';
import { CartStore } from '../../app/(routes)/online-ordering/types';
import { CartInitialState } from './initialState';
import { useAsyncReducer } from './asyncReducer';
import { createActions } from './actions';
// import { SHORT_POLL_TIME } from '@zeus/shared';
// import { setBrowserSessionId } from '../../utils/Session';
// import { usePathname, useSearchParams } from 'next/navigation';

export const CartContext = createContext<{
  state: CartStore | undefined;
  actions: ReturnType<typeof createActions>;
}>({
  state: CartInitialState,
  actions: {} as ReturnType<typeof createActions>,
});

export const CartContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, dispatch] = useAsyncReducer(reducer, CartInitialState);
  const actions = createActions(dispatch);
  // const currentPath = usePathname();
  // const searchParams = useSearchParams();

  // Initial mount - sync cart once
  // useEffect(() => {
  //   const syncData = async () => {
  //     if (
  //       currentPath.includes('checkout') ||
  //       currentPath.includes('post-ordering') ||
  //       (currentPath.includes('gift-cards') && !searchParams.get('view_only'))
  //     ) {
  //       await actions.syncCart({ ...state?.cart, cartType: 'remote' });
  //     } else {
  //       await actions.syncCart({ ...state?.cart, cartType: 'local' });
  //     }
  //   };

  //   setTimeout(() => {
  //     setBrowserSessionId();
  //     syncData();
  //   }, SHORT_POLL_TIME.halfSec);
  // }, []); // Only run once on mount

  return <CartContext.Provider value={{ state, actions }}>{children}</CartContext.Provider>;
};

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};
